/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : PAYPAL : STYLES --------------- ++++++++++ */
export default theme =>({
  paypal:{
    '& .griditem': {
      '& .field':{
          marginRight: pxToEm(30),
          marginTop: pxToEm(20),
          width: pxToEm(310)
      }
    }
  }
});
